import React from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import Nav from "./components/nav";
import "bulma/css/bulma.css";
import { NotFound } from "./components/notFound";
import "aos/dist/aos.css";
import "./components/boxes.css";
import Hero from "./components/hero";
import HeroConten from "./components/heroContent";
import Services from "./components/Services";
import Work from  "./components/work-history";
import Profile from "./components/profile";
const App = () => {
  return (
    <div className="App">
      <Router>
        <Nav />
        <Switch>
          <Route exact path="/">
            <div className="Rotatation">
              <HeroConten/>
              <Hero className="Rotatation"></Hero>
            </div>
            <h2 className="h2-principal">Welcome to my web Portfolio</h2>

            <Profile/>
            <Services/>            
            <Work/>
          </Route>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </Router>
    </div>
  )
}
export default App;
